var ajax = require('./tripletrax.ajax.js');
var validator = require('./tripletrax.validator.js');
var views = require('./tripletrax.views.js');

function registerAuthEvents() {

    $("#password_forgotten").click(function (e) {
        e.preventDefault();

        $("#login_user").fadeOut("slow", function () {
            $("#login_reset_password").fadeIn("slow", function () {
                $('[name="username"]').focus();
            });
        });
    });

    $("#password_remembered").click(function (e) {
        e.preventDefault();

        $("#login_reset_password").fadeOut("slow", function () {
            $("#login_user").fadeIn("slow", function () {
                $("#username").focus();
            });
        });
    });

	$('#device_password').keypress(function(e){
		$(this).data('doLogin', false);
		if (e.which == 13) {
			$(this).data('doLogin', true);
			$(this).blur();
		}
	});

	$("#device_password").focusout(function() {
		var devicename = $('#login_device_form').find('[name="username"]').val();
		var devicePassword = $('#login_device_form').find('[name="password"]').val();
		if (devicename !== '' && devicePassword !=='') {
			getFacilities(devicename, devicePassword).done(function (data) {
				if (data.length > 1) {
					$('#facility_login_selection').removeClass('hide');
				} else {
					$('.tt-login-device').prop('disabled', false);
					$('#facility_login_selection').addClass('hide');

					if ($('#device_password').data('doLogin')) {
						$('.tt-login-device').click();
					}
				}
			});
		} else {
			$('#facility_login_selection').addClass('hide');
		}
	});

	function getFacilities(devicename, devicePassword) {
		return $.Deferred(function (defer) {
			$('.tt-login-device').prop('disabled', true);
			var ajaxData = '&' + jQuery.param({username: devicename, password: devicePassword, _token: $('[name=_token]').val()});
			ajax.ajaxCallDeferred('session/device/facilities', 'POST', ajaxData, false).done(function (data) {
				var comboData = [];
				if (ajax.ajaxSucceeded(data)) {
					for (var i = 0; i < data.length; ++i) {
						comboData.push({ id: data[i][0], text: data[i][1] });
					}

					validator.reinitializeSelect2($('.tt-select-device-login-facilities').parent(), 'input-sm tt-select2 no-padding tt-select-device-login-facilities', '', comboData, false);
					if (data.length === 1) {
						$('.tt-select-device-login-facilities').val(data[0][0]).trigger('change.select2');
					}
					defer.resolve(data);
				}else {
					defer.reject();
				}
			});
		}).promise();
	}

	$("#facility_login_selection").change(function (e) {
		if (e.target.value !== "") {
			$('.tt-login-device').prop('disabled', false);
		} else {
			$('.tt-login-device').prop('disabled', true);
		}
	});

	$("#devicename").focusout(function (e) {
		$('.tt-login-device').prop('disabled', false);
	});

    $("#username").focusout(function () {
        ajax.ajaxCall('session/check', 'POST', 'username=' + $('#login_form').find('[name="username"]').val(), false, function (data) {
            if (data === 'admin') {
                $('#admin_login').removeClass('hidden');
                $('#admin_login_input').prop('checked', 'checked');
            } else {
                $('#admin_login').addClass('hidden');
                $('#admin_login_input').prop('checked', '');
            }
        });
    });

    $("#reset_password").click(function (e) {
        e.preventDefault();

        ajax.ajaxCall($('#form_reset_password').prop('action'), $('#form_reset_password').prop('method'), $('#form_reset_password').serialize(), false, function (data) {
            if (data === '') {
                $("#login_reset_password").fadeOut("slow", function () {
                    $("#message_reset_password").fadeIn("slow", function () {
                    });
                });
            } else {
                $("#error_reset_password").removeAttr('hidden');
            }
        });
    });

    $(".logout").click(function (e) {
        e.preventDefault();

        var text = Lang.get('tripletrax.logout');
        $.SmartMessageBox({
            title: Lang.get('tripletrax.logout', { "username": "<i class='fad fa-sign-out-alt txt-color-orangeDark'></i>  <span class='txt-color-orangeDark'><strong>" + $("#show-shortcut").text() + "</strong></span>" }),
            buttons: '[' + Lang.get('tripletrax.no') + '][' + Lang.get('tripletrax.yes') + ']'
        }, function (ButtonPressed) {
            if (ButtonPressed === Lang.get('tripletrax.yes')) {

                $('#logout_form').submit();
            }
        });
    });

    $('.tt-device-login').click(function (e) {
    	e.preventDefault();

		window.open($(this).data().url, '_blank', 'menubar=no,status=no,titlebar=no,toolbar=no');
	})
}

module.exports.registerAuthEvents = registerAuthEvents;
